import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';
import templateView from './templateView';

// Export utility functions for PDF processing
export { transformHtmlContentForPDF, transformForPDF } from './utils/contentTransforms';

const schema: JSONSchema7 = {
    title: 'Rich Text Editable',
    type: 'object',
    required: ['editorHtml'],
    properties: {
        editorHtml: {
            type: 'string',
            title: 'Rich Text Content',
            default: 'Click to edit...',
        },
        transformData: {
            type: 'boolean',
            title: 'Transform Data',
            default: false,
        },
        functionToTransform: {
            type: 'string',
            title: 'Data Transformation Function',
            description:
                'JavaScript function to transform data properties accessed via data.propertyName',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
    },
    dependencies: {
        ...customSchemas.layoutSchema.LayoutSchema.dependencies,
        transformData: {
            oneOf: [
                {
                    properties: {
                        transformData: { enum: [true] },
                        functionToTransform: {
                            type: 'string',
                            description:
                                'Function to transform data. Access data properties using data.propertyName',
                        },
                    },
                },
                {
                    properties: {
                        transformData: { enum: [false] },
                    },
                },
            ],
        },
    },
};

const groups = [
    {
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: ['editorHtml'],
        'Data Transformation': ['transformData', 'functionToTransform'],
    },
];

const uiSchema = {
    'ui:groups': groups,
    ...customSchemas.textSchema.TextSchema.uiSchema,
    ...customSchemas.styleSchema.StyleSchema.uiSchema,
    ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
    ...customSchemas.ComponentInfoSchema.ComponentInfoSchema.uiSchema,
    editorHtml: {
        'ui:widget': 'RichTextEditableWidget',
    },
    transformData: {
        'ui:widget': 'CustomCheckbox',
    },
    functionToTransform: {
        'ui:widget': 'JSEditor',
    },
};

const RichTextEditableWidget: commonTypes.IWidget = {
    schema,
    uiSchema,
    templateView,
    contentPlaceHolders: ['children'],
    id: 'RichTextEditable',
    group: 'component',
    initialData: () => ({}),
};

export default RichTextEditableWidget;
